var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"baseTemplate",attrs:{"id":"featuresTree"}})
}
var staticRenderFns = []

export { render, staticRenderFns }